import React from 'react';
import {PublicNavigationStack} from './PublicNavigationStack';

export const NonMemberApp = () => {
  return <PublicNavigationStack />;
};
